import { useMemo } from "react";

import { useDeveloperHasPermission } from "@services/useDeveloperHasPermission";

import { hasCurrentsPermissions } from "./hasCurrentsPermissions";

export const useCurrentsPermissions = (): ReturnType<typeof hasCurrentsPermissions> => {
  const hasPermission = useDeveloperHasPermission();

  return useMemo(() => hasCurrentsPermissions({ hasPermission }), [hasPermission]);
};
